import { render, staticRenderFns } from "./BaseEntityText.vue?vue&type=template&id=2cfcdc16&"
import script from "./BaseEntityText.vue?vue&type=script&lang=ts&"
export * from "./BaseEntityText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports